<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
    v-card
      v-card-title.px-4
        v-spacer
        .text-lg.font-bold Redeem offer
        v-spacer
      v-divider
      div.py-6.px-8
        template(v-if="step === 0")
          redeem-offer-one(:offer="offer")
        template(v-if="step === 1")
          redeem-verification-code(v-model="otp")
        template(v-if="step === 2")
          redeem-offer-finish(:customer="customer" :selected-offer="offer")
      v-divider
      v-card-actions.px-6
        v-spacer
        v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
        v-btn.button-md.neutral700.white--text(v-if="step === 2" depressed @click="closeDialog") {{ $t('finish') }}
        v-btn.button-md.neutral700.white--text(v-else :loading="isLoading" depressed :disabled="isDisabledContinue" @click="handleContinue") {{ $t('continue') }}
</template>

<script>
import RedeemOfferOne from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferOne.vue";
import RedeemVerificationCode from "@/components/clinic/checkout/marketing/redeem/RedeemVerificationCode.vue";
import RedeemOfferFinish from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferFinish.vue";
import {mapActions, mapGetters} from "vuex";


export default {
  components: {
    RedeemOfferFinish, RedeemVerificationCode, RedeemOfferOne,
  },
  props: {
    open: {
      type: Boolean,
    },
    offer: {
      type: Object,
      required: true
    },
    customer: {
      type: Object,
      required: true,
    },
    leadId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      step: 0,
      selectedOffer: null,
      otp: null,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isDisabledContinue () {
      if (this.step === 0) {
        return !this.offer
      }
      if (this.step === 1) {
        return !this.otp || this.otp.toString().length !== 4
      }
      return false
    },
    otpRequestPayload() {
      return {
        phone: this.customer.phone,
      }
    },
    otpCheckPayload() {
      return {
        phone: this.customer.phone,
        otp: `${this.otp}`
      }
    },
    redeemOfferPayload() {
      return {
        coupon: this.offer.id,
        lead: this.leadId,
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    closeDialog() {
      this.showDialog = false
    },
    async handleContinue() {
      if (this.step === 0) {
        const requested = await this.requestOTP()
        if (!requested) return
        this.step = 1
        return
      }
      if (this.step === 1) {
        const isValidOTP = await this.checkOTP()
        if (!isValidOTP) return
        await this.redeemOffer()
        this.handleUpdated()
        this.step = 2
      }
    },
    async requestOTP() {
      try {
        this.isLoading = true
        const url = `/marketing/${this.company.slug}/redeems/request_otp`
        const { data } = await this.$axios.post(url, this.otpRequestPayload)
        this.updateActivityLog(url, this.otpRequestPayload, data, 'POST', 'Redeem offer request OTP', null)
        return true
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return false
      } finally {
        this.isLoading = false
      }
    },
    async checkOTP() {
      const url = `/marketing/${this.company.slug}/redeems/check_otp`
      try {
        this.isLoading = true
        const { data } = await this.$axios.post(url, this.otpCheckPayload)
        this.updateActivityLog(url, this.otpCheckPayload, data, 'POST', 'Redeem offer check OTP - success', null)
        return true
      } catch (error) {
        if (error.response.status === 400) {
          this.updateActivityLog(url, this.otpCheckPayload, error.response.data, 'POST', 'Redeem offer check OTP - invalid TAC', null)
          this.showMessage(['error', 'Invalid TAC'])
        } else {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        }
        return false
      } finally {
        this.isLoading = false
      }
    },
    async redeemOffer() {
      try {
        const url = `/marketing/${this.company.slug}/redeems`
        const { data } = await this.$axios.post(url, this.redeemOfferPayload)
        this.updateActivityLog(url, this.redeemOfferPayload, data, 'POST', 'Redeem offer', data.id)
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
    },
    updateActivityLog (endpoint, payload, response, method, activity, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'OTP',
        activity: activity,
        raw_data: { endpoint, payload, response: response, method}
      }
      this.$axios.post('/users/logs', data)
          .catch(() => {})
    },
    handleUpdated() {
      this.$emit('updated')
    }
  },
}
</script>

<style scoped>
</style>